import React, { Component } from 'react';

import { DropdownMenu, AccessibleFakeButton, IconSeparator, 
    FontIcon, Avatar, ListItem } from 'react-md';

import { firstChar } from '../common/formaters';
import { decodeJwtObject } from '../common/base64'

const COLORS = Avatar.defaultProps.suffixes;

class UserMenu extends Component {
    
    constructor(props) {
        super(props);

        this.state = {
            
        }
    }

    render() {

        return (
            <DropdownMenu
                id="user-menu"
                menuItems={[
                    <ListItem key={0} primaryText="Editar" onClick={this.props.onEdit}/>, 
                    <ListItem key={1} primaryText="Sair" onClick={this.props.onLogout}/>
                ]}
                anchor={{
                    x: DropdownMenu.HorizontalAnchors.CENTER,
                    y: DropdownMenu.VerticalAnchors.OVERLAP,
                }}
                position={DropdownMenu.Positions.CENTER}
                animationPosition="below"
                className="tw-user-menu"
            >
                <AccessibleFakeButton
                    component={IconSeparator}
                    iconBefore
                    label={
                    <IconSeparator label={this.renderUserName()}>
                        <FontIcon>arrow_drop_down</FontIcon>
                    </IconSeparator>
                    }
                >
                    <Avatar suffix={COLORS[19]}>{firstChar(this.renderUserName())}</Avatar>
                </AccessibleFakeButton>
            </DropdownMenu>
        )
    }

    renderUserName = () => {
        const accessToken = localStorage.getItem("accessToken");
        const currentUser = accessToken ? decodeJwtObject(accessToken).usuario : null;
        
        return currentUser ? currentUser.nome : "";
    }
}

export default UserMenu;


// WEBPACK FOOTER //
// ./src/components/UserMenu.js